var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullscreen-centered always-on-top dark-stars"},[_c('div',[_vm._m(0),_c('div',{staticClass:"button-row"},[_c('button',{staticClass:"better-mobile-btn green",on:{"click":_vm.done}},[_vm._v("Done")])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scanner-users"},[_c('h4',{staticClass:"user-name"},[_vm._v("You're All Set!")])])
}]

export { render, staticRenderFns }